/* eslint-disable react/prop-types */
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import fixTableCellWidth from "../../utils/fixTableCellWidth";
import SoftBadge from 'components/SoftBadge';
import useModal from "hooks/useModal";
import InvestorGhollaksModal from './InvestorGhollaksModal';
import { Grid } from '@mui/material';
import SoftTypography from 'components/SoftTypography';
import SoftBox from 'components/SoftBox';
import SoftInput from 'components/SoftInput';
import SoftButton from "components/SoftButton";
import { useNavigate } from 'react-router-dom';
import TargetModal from './TargetModal';

function createData(id, full_name, phone_number, phone_number_verified_at, email, email_verified_at, national_code, created_at, operation) {
    return {
        id,
        full_name,
        phone_number,
        phone_number_verified_at,
        email,
        email_verified_at,
        national_code,
        created_at,
        operation
    };
}

function Row(props) {
    const { row } = props;

    return (
        <React.Fragment>
            <TableRow
                sx={{ '& > *': { borderBottom: 'unset' }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
                <TableCell className="tablecell" align="left" title={row.full_name}
                    style={fixTableCellWidth("160px")}>{row.full_name}</TableCell>
                <TableCell className="tablecell" align="left" title={row.phone_number_verified_at === null ? "تایید نشده" : "تایید شده"}
                    style={fixTableCellWidth("160px")}>{row.phone_number}</TableCell>
                <TableCell className="tablecell" align="left" title={row.email_verified_at === null ? "تایید نشده" : "تایید شده"}
                    style={fixTableCellWidth("160px")}>{row.email}</TableCell>
                <TableCell className="tablecell" align="left" title={row.national_code}
                    style={fixTableCellWidth("160px")}>{row.national_code}</TableCell>
                <TableCell className="tablecell" align="left" title={new Date(row.created_at).toLocaleString("fa-IR")}
                    style={fixTableCellWidth("150px")}>{new Date(row.created_at).toLocaleString("fa-IR")}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("100px")}>{row.operation}</TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function InvestorTable({ data, filterInfo, handleFilterChange, onFilterClick }) {
    const [modals, updateModal, closeModal] = useModal({
        ghollaks: { state: false },
        target: { state: false },
    });
    const closeGhollaksModal = () => closeModal("ghollaks");
    const closeTargetModal = () => closeModal("target");
    const navigate = useNavigate()
    const rows = data.map(item => createData(item.id, `${item?.user?.first_name} ${item?.user?.last_name}`, item?.user?.phone_number, item?.user?.phone_number_verified_at,
        item?.user?.email, item?.user?.email_verified_at, item?.user?.national_code, item?.user?.created_at,
        <section style={{ display: "flex", cursor: 'pointer' }}>
            <SoftBadge variant="contained"
                onClick={() => navigate(`/qrcode?investor_id=${item.id}`)}
                badgeContent="کیوآر"
                color="primary" size="xs" />
            <SoftBadge variant="contained"
                onClick={() => updateModal("target", { state: true, userId: item.user_id })}
                badgeContent="اهداف"
                color="success" size="xs" />
            <SoftBadge variant="contained"
                onClick={() => updateModal("ghollaks", { state: true, userId: item.user_id })}
                badgeContent="قلک ها"
                style={{ cursor: 'pointer' }}
                color="secondary" size="xs" />
        </section>
    ))

    return (
        <>
            <TableContainer component={Paper}>
                <Table>
                    <Grid container gap={2} mb={2} pl={2}>
                        <Grid item xs={12} md={6} lg={2}>
                            <SoftBox mb={1} ml={0.5}>
                                <SoftTypography component="label" variant="caption" fontWeight="bold">
                                    نام
                                </SoftTypography>
                            </SoftBox>
                            <SoftInput value={filterInfo?.fullName} name="fullName" onChange={handleFilterChange}
                                type="text" />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                            <SoftBox mb={1} ml={0.5}>
                                <SoftTypography component="label" variant="caption" fontWeight="bold">
                                    کد ملی
                                </SoftTypography>
                            </SoftBox>
                            <SoftInput value={filterInfo?.nationalCode} name="nationalCode" onChange={handleFilterChange}
                                type="text" />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                            <SoftBox mb={1} ml={0.5}>
                                <SoftTypography component="label" variant="caption" fontWeight="bold">
                                    شماره موبایل
                                </SoftTypography>
                            </SoftBox>
                            <SoftInput placeholder="98xxxxx" value={filterInfo?.phoneNumber} name="phoneNumber" onChange={handleFilterChange}
                                type="text" />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <SoftButton size="small" onClick={onFilterClick} style={{ marginTop: 40, width: 100 }} variant="gradient" color="info">
                                فیلتر
                            </SoftButton>
                        </Grid>
                    </Grid>
                    <TableHead>
                        <TableRow>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>نام</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>موبایل</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("170px")}>ایمیل</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>کدملی</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>تاریخ ایجاد</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>عملیات</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ display: 'block' }}>
                        {rows.map((row) => (
                            <Row key={row.id} row={row} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {modals.ghollaks.state && <InvestorGhollaksModal modalInfo={modals.ghollaks} closeModal={closeGhollaksModal} />}
            {modals.target.state && <TargetModal modalInfo={modals.target} closeModal={closeTargetModal} />}
        </>
    );
}
